/*
 * Vite inlines import.meta.env at build time; there is no process.env in the
 * browser bundle. Both values default to empty, which makes every request
 * same-origin -- what nginx serves in production and what the dev proxy fakes.
 */
export default {
  host: import.meta.env.VITE_API_BASE || '',
  port: import.meta.env.VITE_API_PORT || '',
};
